export type SectionType =
  | "period"
  | "income"
  | "required"
  | "desired"
  | "assets"
  | "debts"
  | "goals";

export interface FormInputItem {
  id: string;
  text: string;
  amount: number;
  comment?: string;
  date?: string;
  badge?: "debt" | "goal";
}

export interface FormSection {
  id: SectionType;
  title: string;
  inputs: {
    placeholders: string[];
    items: FormInputItem[];
  };
  color: string;
  canAddItems: boolean;
}

export interface FormData {
  period: {
    startDate: string;
    endDate: string;
  };
  city: string;
  dailySpending: string;
  sections: Partial<Record<SectionType, FormSection>>;
  aiComment: string;
}

export const MAIN_FORM_SECTIONS: SectionType[] = [
  "period",
  "income",
  "required",
  "desired",
];

export const ADDITIONAL_FORM_SECTIONS: SectionType[] = [
  "assets",
  "goals",
  "debts",
];

export const DEFAULT_FORM_SECTIONS: Record<
  SectionType,
  Omit<FormSection, "items">
> = {
  period: {
    id: "period",
    title: "Период",
    inputs: {
      placeholders: ["С какого числа?", "До какого числа?"],
      items: [],
    },
    color: "#D87B7B",
    canAddItems: false,
  },
  income: {
    id: "income",
    title: "Доходы",
    inputs: {
      placeholders: ["Откуда деньги?", "Сколько?", "Когда их получишь?"],
      items: [],
    },
    color: "#69B5D3",
    canAddItems: true,
  },
  required: {
    id: "required",
    title: "Обязательные расходы",
    inputs: {
      placeholders: ["На что?", "Сколько?", "Когда платить?"],
      items: [],
    },
    color: "#507B5D",
    canAddItems: true,
  },
  desired: {
    id: "desired",
    title: "Необязательные расходы",
    inputs: {
      placeholders: ["На что?", "Сколько?", "Когда платить?"],
      items: [],
    },
    color: "#FCD688",
    canAddItems: true,
  },
  assets: {
    id: "assets",
    title: "Активы",
    inputs: {
      placeholders: ["Что у тебя есть?", "Сколько?", "Что важно учесть?"],
      items: [],
    },
    color: "#CAEEFC",
    canAddItems: true,
  },
  debts: {
    id: "debts",
    title: "Долги",
    inputs: {
      placeholders: ["Кому должен?", "Сколько?", "Когда нужно вернуть?"],
      items: [],
    },
    color: "#FFE8B9",
    canAddItems: true,
  },
  goals: {
    id: "goals",
    title: "Цели",
    inputs: {
      placeholders: ["На что копишь?", "Сколько?", "К какому сроку?"],
      items: [],
    },
    color: "#ABD0B7",
    canAddItems: true,
  },
};
